import VouchersPage from "./VouchersPage";

export default [
    {
        path: "/vouchers",
        name: "vouchers",
        component: VouchersPage
    }
]
